import React from 'react';
import { useRef, useState, useEffect, useMemo, Suspense, useRender } from 'react'
import { extend, Canvas, useFrame, Dom, useLoader, useThree, render } from 'react-three-fiber'
import { TransformControls } from 'three/examples/jsm/controls/TransformControls';
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls"
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import { Man2, FallBackBox, Woman } from "./charachters"
import * as THREE from "three"

extend({ OrbitControls, TransformControls });


function Scene(props) {

  const gridColor = '#873d00'
  const majorLinesColor = '#ff9c4a'
  const { camera, gl, scene } = useThree();
  const [clicked, set] = useState(true)
  const meshRef = useRef();
  const controlsRef = useRef();
  const gridRef = useRef()
  const group = useRef();
  const modelBones = props.modelBones

  // gridRef.visible = props.groundVisible
  // console.log(props.groundVisible)

  const [transformControl, setTControl] = useState();

  useFrame(() => controlsRef.current && controlsRef.current.update());

  // Instantiate the TransformController: this is a hack, because
  // this tool takes part of three/examples, and is not stable in react-three-fiber version
  useEffect(() => {
    const callback = (event) => {
      controlsRef.current.enabled = !event.value
    }
    // transControl.addEventListener("dragging-changed", callback)
    if (!transformControl && meshRef.current) {
      let transformC = new TransformControls(camera, gl.domElement);
      scene.add(transformC);
      setTControl(transformC);
      transformC.attach(meshRef.current);
      transformC.addEventListener('dragging-changed',
        callback)
    }

    return () => {
      if (transformControl) {
        scene.remove(transformControl);
        setTControl(undefined);
      }
    };
  }, [transformControl, camera, scene, gl]);


  // gridRef.traverse(function (child) {
  //   child.visible = props.groundVisible;
  // });
  


  camera.fov = 45;
  camera.aspect = window.innerWidth / window.innerHeight;
  camera.near = 0.1;
  camera.far = 1000;

  camera.up.set(0, 1, 0);
  camera.position.set(-5, 7, 30);

  const models = {
    "man": {
      "model_name": "/assets/3d/man2.glb",
      "geometry_name": "Realistic_White_Male_Low_Poly",
      "group_name": "Armature",
      "scale": 0.8
    },
    "woman": {
      "model_name": "/assets/3d/woman.glb",
      "geometry_name": "Realistic_White_Female_Low_Poly",
      "group_name": "Scene",
      "scale": 0.3
    }
  }

  return (
    <>
      <mesh
        ref={meshRef}
        position={[0, -10, 0]}
      >

        <mesh
          ref={gridRef}
        >
          <gridHelper
            visible={props.groundVisible}
            args={[100, 50, majorLinesColor, gridColor]} />
          <meshNormalMaterial attach='material' />
        </mesh>
        {/* <Woman
                  orbit={controlsRef}
                  camera={camera}
                  gl={gl}
                  scene={scene}
                  /> */}
        <Suspense fallback={<FallBackBox />}>
          <mesh ref={meshRef}>
            <Man2
              getRigBones={props.getRigBones}
              orbit={controlsRef}
              camera={camera}
              gl={gl}
              scene={scene}
              model={models['woman']}
              modelBones={modelBones}
            // setTControl={setTControl}
            />
          </mesh>

        </Suspense>

      </mesh>

      <orbitControls
        ref={controlsRef}
        args={[camera, gl.domElement]}
        enableRotate
        enablePan={false}
        maxDistance={100}
        minDistance={5}
      />

    </>
  );
}

export default Scene;